module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"home":{"errors":{"payment":"There was a problem with your payment information. Please reconfirm and try again. If you continue receiving this error, please contact Aces.","other":"There was a problem submitting your reservation. Please try again. If you continue receiving this error, please contact Aces."}}}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/Home.vue
// module id = 180
// module chunks = 1